'use client';

import { useAtomValue, useSetAtom } from 'jotai';

import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';
import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { currentVehicleIdAtom } from '@core/Atoms/Vehicle/CurrentVehicleId.atom';
import Button from '@gds/Button/Button';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';
import { generateLeadTrackingData } from '@lead-forms/Tracking/LeadForms.tracking';
import { leadCtasConfig } from '@pdp/Components/LeadCTAs/LeadCtaConfig';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import type { PdPMessagesKeys } from 'Components/Pdp/Pdp.messages';

import styles from './DealerInformationSection.module.css';

interface Props {
  pdpStrings: Record<PdPMessagesKeys, string>;
}

export const BookAppointmentCTA = ({ pdpStrings }: Props) => {
  const flags = useAtomValue(flagsAtom);
  const vehicle = useAtomValue(currentVehicleAtom)!;
  const listingId = useAtomValue(currentVehicleIdAtom);
  const searchParams = useAtomValue(searchParamsAtom);
  const formState = useAtomValue(formStateAtom);
  const userId = useAtomValue(userIdAtom);
  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  const handleRequestBtnClick = (leadType: 'book-appointment') => {
    const {
      leadStart: { event, context },
    } = generateLeadTrackingData({
      searchParams,
      userId,
      formState,
      leadFormId: leadType,
      leadId: '',
      listingId,
      vehicle,
      ctaLocation: 'pdp',
      leadAction: '',
    });
    trackCustomEvent({ event, context });

    toggleLeadForm(leadType);
  };
  const isCta = leadCtasConfig['book-appointment'].isActive({ flags, vehicle }) as boolean;
  if (!isCta) return null;
  return (
    <Button
      variant="outlined"
      onClick={() => handleRequestBtnClick('book-appointment')}
      className={styles.bookAppointmentCta}
      data-test-id="bookAppointmentButton"
    >
      {pdpStrings.bookAppointmentButton}
    </Button>
  );
};
